
export default {
  name: 'SLoadingState',
  props: {
    asyncLoadingMessage: {
      type: String,
      default: 'Chargement...',
    },
  },
};
